module.exports = res => {
  if (!res.ok) {
    throw Error(`${res.statusText}: ${res.url}`);
  }
  if (res.status === 204) {
    return Promise.resolve(null);
  }
  return res.text();
};
